import React from 'react'

import i18n from 'live/services/i18n'

import { isEmpty } from '../../../utils'
import { Container, RowContainer } from './styles'

const sum = (obj: number[], key: string): number => obj.reduce((a, b) => a + (b[key] || 0), 0)
const normalizeString = (str: string): string =>
    str
        ?.toLowerCase()
        ?.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
const options = {
    toleravel: {
        label: 'Tolerable',
        icon: 'exclamation',
        color: '#F89300'
    },
    'amplamente aceitavel': {
        label: 'Widely Acceptable',
        icon: 'check',
        color: '#01C292'
    },
    intoleravel: {
        label: 'Intolerable',
        icon: 'times',
        color: '#C43535'
    }
}

const Row = ({ data, onClick, index }): JSX.Element => {
    const preventionAverage = data?.prevention / data?.threats
    const mitigationAverage = data?.recovery / data?.outcome

    const preventionStatus = preventionAverage <= 0 ? '#01C292' : preventionAverage >= 0.75 ? '#C43535' : '#F89300'
    const mitigationStatus = mitigationAverage <= 0 ? '#01C292' : mitigationAverage >= 0.75 ? '#C43535' : '#F89300'
    const colorBarrierDegraded = (value: number): string =>
        value <= 0 ? '#01C292' : value >= 0.75 ? '#C43535' : '#F89300'

    return (
        <RowContainer
            color={options[normalizeString(data?.status)].color}
            preventionColor={preventionStatus}
            mitigationColor={mitigationStatus}
        >
            <div className="Info">
                <div onClick={e => onClick(e, data?.id, data?.key, index)} className="Id">
                    {data?.key?.replace(/\s+/g, '')}
                </div>
                <div className="Label">
                    <div className="Icon">
                        <i className={`far fa-${options[normalizeString(data?.status)].icon}`} />
                    </div>

                    {i18n(options[normalizeString(data?.status)]?.label)}
                </div>
            </div>

            <div className="Count">
                <div className="Number Prevention">
                    <span style={{ color: colorBarrierDegraded(data?.threatsDeprecated) }}>
                        {data?.threatsDeprecated}
                    </span>{' '}
                    / {data?.threats_barriers}
                </div>
            </div>

            <div className="Count">
                <div className="Number Mitigation">
                    <span style={{ color: colorBarrierDegraded(data?.consequencesDeprecated) }}>
                        {data?.consequencesDeprecated}
                    </span>{' '}
                    / {data?.consequences_barriers}
                </div>
            </div>
        </RowContainer>
    )
}
interface ListBowtieCardProps {
    event?: any
    name?: string
    onClick?: Function
    expand?: boolean
    setShowDetails?: Function
}
const ListBowTieCard = ({ event, name, onClick, expand, setShowDetails }: ListBowtieCardProps): JSX.Element => {
    const totalBowtiesDegraded =
        !isEmpty(event) && event[`${name?.toLowerCase()}MahDegraded`]?.filter(d => d?.degraded)?.length

    const sortBowtieList = (fieldA: Record<string, number>, fieldB: Record<string, number>): number => {
        if (fieldA.key < fieldB.key) {
            return -1
        }

        if (fieldA.key > fieldB.key) {
            return 1
        }

        return 0
    }

    return (
        <Container
            className="ListBowTieCard"
            open={expand}
            length={event?.bowtieList?.length || 0}
            onClick={ev => onClick(ev, event?.bowtieList?.length || 0)}
        >
            <div className="ListHeader">
                <div className="Title">
                    <div className="Icon">
                        <i className="far fa-exclamation-triangle"></i>
                    </div>
                    {i18n(name)}
                </div>

                <div className="Info">
                    <span>{event?.deprecated}</span>
                    <span>
                        {' '}
                        /{event?.total} {i18n('degraded barriers')}
                    </span>
                    <div className="Icon">
                        <i className="fas fa-chevron-down"></i>
                    </div>
                </div>
            </div>

            <div className="ListBody">
                <div className="Top">
                    <div className="Info">
                        <div className="Number">
                            <span>{totalBowtiesDegraded}</span> / {event?.bowtieList.length}
                        </div>
                        <div className="Label">{i18n('Bowties with degraded barriers')}</div>
                    </div>

                    <div className="Count">
                        <div className="Label">{i18n('Prevention')}</div>
                        <div className="Number">
                            <span>{sum(event?.bowtieList, 'threatsDeprecated')}</span> / {event?.prevention}
                        </div>
                    </div>

                    <div className="Count">
                        <div className="Label">{i18n('Mitigation')}</div>
                        <div className="Number">
                            <span>{sum(event?.bowtieList, 'consequencesDeprecated')}</span> / {event?.recovery}
                        </div>
                    </div>
                </div>

                <div className="Bottom">
                    {event?.bowtieList.sort(sortBowtieList).map((item, i) => (
                        <Row key={i} data={{ ...item, ...event }} onClick={setShowDetails} index={i} />
                    ))}
                </div>
            </div>
        </Container>
    )
}

export default ListBowTieCard
